import { AritoIcon, BottomActionBarV2, DialogV2, AritoFormV2 } from '@/components/custom/erp';
import { formSchema, initialValues, type FormValues } from '../schemas';
import type { NganHang, NganHangInput } from '@/types/schemas';
import { FormMode } from '@/types/form';
import BasicForm from './BasicForm';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;
  onSubmit?: (data: NganHangInput) => void;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;
  initialData?: NganHang | null;
  zIndex?: number;
}

function FormDialog({
  mode,
  open,
  onClose,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData,
  onSubmit,
  zIndex
}: FormDialogProps) {
  const handleSubmit = async (data: FormValues) => {
    onSubmit?.(data as NganHangInput);
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
      maxWidth='lg'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={281} />}
      zIndex={zIndex}
    >
      <AritoFormV2<FormValues>
        mode={mode}
        hasAritoActionBar={false}
        schema={formSchema}
        onSubmit={handleSubmit}
        initialData={initialData || initialValues}
        className='w-full md:min-w-[800px]'
        headerFields={<BasicForm formMode={mode} />}
        bottomBar={
          <BottomActionBarV2
            mode={mode}
            onAdd={onAddButtonClick}
            onEdit={onEditButtonClick}
            onDelete={onDeleteButtonClick}
            onCopy={onCopyButtonClick}
            onClose={onClose}
          />
        }
      />
    </DialogV2>
  );
}

export default FormDialog;
